<template>
  <div>
    <h2 class="mb-2">
      {{ title }}
    </h2>
    <v-menu
      v-model="addMenu"
      class="mb-2"
      :close-on-content-click="false"
      :close-on-click="false"
      :nudge-width="400"
      offset-x
    >
      <v-btn
        slot="activator"
        small
        :data-test="`${dataTest}OpenMenu`"
      >
        Добавить
      </v-btn>
      <v-card>
        <v-card-text class="pb-0">
          <v-text-field
            v-model="newElement"
            :label="title"
            :mask="mask"
            :rules="rules"
            outline
            height="44"
          />
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn
            small
            flat
            :data-test="`${dataTest}CloseMenu`"
            @click="closeMenu()"
          >
            Отмена
          </v-btn>
          <v-btn
            small
            color="primary"
            flat
            :data-test="`${dataTest}Add`"
            :disabled="!newElement"
            @click="addElement()"
          >
            Ок
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-menu>

    <v-flex
      xs12
      sm6
      md4
    >
      <v-list
        class="client-list"
        :style="itemsPerView(clientItemsPerView)"
      >
        <template v-for="(item, index) in elements">
          <v-list-tile :key="index">
            <v-list-tile-content class="list-element">
              <div v-if="!item.editable">
                {{ item.title }}
              </div>
              <v-text-field
                v-else
                v-model="editableElement"
                hide-details
                outline
                height="35"
                style="width: 100%"
              />
            </v-list-tile-content>
            <v-list-tile-action>
              <v-layout>
                <v-icon
                  v-if="!item.editable"
                  @click="openElementEditor(item)"
                >
                  edit
                </v-icon>
                <v-icon
                  v-else
                  :disabled="!editableElement"
                  @click="updateElement(item, editableElement)"
                >
                  check
                </v-icon>
                <v-icon @click="deleteElement(item)">
                  delete
                </v-icon>
              </v-layout>
            </v-list-tile-action>
          </v-list-tile>
          <v-divider
            v-if="index + 1 < elements.length"
            :key="`divider-${index}`"
          />
        </template>
      </v-list>
    </v-flex>
  </div>
</template>
<script>
export default {
  props: ["value", "title", "mask", "rules", "dataTest", "clientItemsPerView"],
  data() {
    return {
      addMenu: false,
      newElement: "",
      elements: [],
      editableElement: "",
    };
  },
  watch: {
    value: {
      handler(newValue) {
        this.elements = newValue.length
          ? newValue.map((v) => {
            return { title: v, editable: false };
          })
          : [];
      },
      immediate: true,
    },
  },
  methods: {
    closeMenu() {
      this.addMenu = false;
      this.newElement = "";
    },
    addElement() {
      this.elements.push({ title: this.newElement, editable: false });
      this.closeMenu();
      this.$emit("input", [
        ...new Set(
          this.elements.map((e) => this.$options.filters.trimSpaces(e.title)),
        ),
      ]);
    },
    deleteElement(item) {
      const delIndex = this.elements.indexOf(item);
      if (delIndex !== -1) {
        this.elements.splice(delIndex, 1);
      }
      this.$emit("input", [
        ...new Set(
          this.elements.map((e) => this.$options.filters.trimSpaces(e.title)),
        ),
      ]);
    },
    openElementEditor(item) {
      item.editable = true;
      this.editableElement = item.title;
    },
    updateElement(item, newItem) {
      if (item.title === newItem) {
        item.editable = false;
        return;
      }
      const index = this.elements.findIndex((e) => e.title === item.title);
      this.elements.splice(index, 1, { title: newItem, editable: false });
      this.$emit("input", [
        ...new Set(
          this.elements.map((e) => this.$options.filters.trimSpaces(e.title)),
        ),
      ]);
      this.elements.forEach((e) => (e.editable = false));
    },
    itemsPerView(items) {
      if (items < 1) {
        return;
      }
      return `max-height: ${items * 40}px; overflow-y: auto;`;
    },
  },
};
</script>
<style>
.list-element {
  height: 35px;
}
.list-element .v-text-field--outline input {
  margin-top: 10px;
}
.client-list.v-list .v-list__tile:not(.v-list__tile--avatar) {
  height: auto;
}
</style>
